import type { AnimalItem } from "../mocks/animals";
import { createServerStateStore } from "../lib/serverState";

type AnimalUpdater =
  | AnimalItem[]
  | ((prev: AnimalItem[]) => AnimalItem[]);

const store = createServerStateStore<AnimalItem[]>("animals", []);

export function getAnimals() {
  return store.getState();
}

export async function rehydrateAnimals() {
  return store.rehydrate();
}

export async function setAllAnimals(updater: AnimalUpdater) {
  return store.setState(updater);
}

export async function setAnimals(updater: AnimalUpdater) {
  return store.setState(updater);
}

export async function updateAnimalById(
  animalId: number,
  updater: Partial<AnimalItem> | ((current: AnimalItem) => AnimalItem)
) {
  return store.setState((prev) =>
    prev.map((item) => {
      if (item.id !== animalId) return item;

      if (typeof updater === "function") {
        return updater(item);
      }

      return {
        ...item,
        ...updater,
      };
    })
  );
}

export async function upsertAnimal(nextAnimal: AnimalItem) {
  return store.setState((prev) => {
    const index = prev.findIndex((item) => item.id === nextAnimal.id);

    if (index === -1) {
      return [...prev, nextAnimal];
    }

    const next = [...prev];
    next[index] = nextAnimal;
    return next;
  });
}

export async function removeAnimalById(animalId: number) {
  return store.setState((prev) =>
    prev.filter((item) => item.id !== animalId)
  );
}

export function subscribeAnimals(listener: () => void) {
  return store.subscribe(listener);
}

export async function resetAnimalsStore() {
  return store.reset();
}